import type { FC } from 'react';
import { useDesktop } from '@utils/hooks/useDesktop';
import NavBarMobile from './NavBarMobile';
import NavBarDesktopV2 from './NavBarDesktopV2';

const NavBar: FC = () => {
  const isDesktop = useDesktop();

  return isDesktop ? <NavBarDesktopV2 /> : <NavBarMobile />;
};

export default NavBar;
